export const HERO_ICON_PREFIX = 'hero_'
export const CUSTOM_ICON_PREFIX = 'custom_'
export const ACTIVE_STATUS = 'active'
export const INACTIVE_STATUS = 'inactive'
export const ALL_STATUS = 'all status'
export const APPROVE_STATUS = 'approve'
export const REJECT_STATUS = 'reject'
export const WAITING_STATUS = 'waiting'

export const SIDEMENU_ICON_SIZE = 21

export const RANDOM_TEAM = 'random'
export const CUSTOM_TEAM = 'custom'

export const HTTP_METHOD_GET = 'get'

export const ITEM_PER_PAGE = 50
export const MAX_PAGE_VISIBLE = 6
